import React from "react";
import {getConfEmails, updateConfEmail} from "../api/ConfApi";
import {EmailTemplateEditor} from "../shared/EmailTemplateEditor";
import {hasPermission} from "../api/UserApi";
import {PERMISSION_CONF_ADMIN, PERMISSION_STAFF} from "../constants";

export function ConfSettingsEmail() {
  const isStaffOrAdmin = hasPermission(PERMISSION_STAFF) || hasPermission(PERMISSION_CONF_ADMIN);

  return (
      <EmailTemplateEditor
          loadTemplates={getConfEmails}
          saveTemplate={updateConfEmail}
          canEdit={isStaffOrAdmin}
          intro={`You can ${isStaffOrAdmin ? 'edit' : 'view'} the content of emails sent by the server for this conference.`}
      />
  );
}
